// Is the jquery element scrollable
export const isScrollable = ($el) => {
  const el = $el[0];
  return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}